import { createFolderThunk } from '../../../redux/thunks/folder';
import CustomInput from '../../reusable/input';
import CustomModal from '../../modals';
import { nameSchema } from '../../../schema';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Button } from '@mui/material';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';


const CreateFolderModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { loaders } = useSelector((state: RootState) => state.folder);

    const handleSubmit = async (values: {name: string}) => {
        // Handle Submission
        try {
            await dispatch(createFolderThunk({ name: values.name, client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
            onClose();
        } catch (e) {
            // Catch errors
        }
    };

    return <CustomModal open={open} handleClose={loaders.isCreating ? () => null : onClose} title="Name the folder">
        <Formik
            initialValues={{
                name: ''
            }}
            validationSchema={nameSchema}
            onSubmit={handleSubmit}
        >
            {({ values, handleChange, handleBlur, errors, touched }) => (
                <Form>
                    {/* Input for stage name */}
                    <CustomInput
                        value={values.name}
                        onChange={handleChange('name')}
                        onBlur={handleBlur('name')}
                        error={touched.name && errors.name}
                        fullWidth
                        label="Folder name"
                        placeholder="Enter folder name"
                        variant="outlined"
                        disabled={loaders.isCreating}
                        mandatoryFields={true}
                    />
                    {/* Action buttons for cancel and submit */}
                    <Box display="flex" gap={2} mt={2}>
                        <Button variant="outlined" color="secondary" onClick={onClose} fullWidth disabled={loaders.isCreating}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="contained" color="primary" fullWidth disabled={loaders.isCreating}>
                            {loaders.isCreating ? 'Creating...' : 'Create'}
                            {/* {loaders.isUpdating ? 'Updating...' : selectedStage?.id ? 'Update' : loaders.isCreating ? 'Creating...' : 'Create'} */}
                        </Button>
                    </Box>
                </Form>
            )}
        </Formik>
    </CustomModal>;
};

export default CreateFolderModal;